<template>
    <base-card-select :isSelected="isSelected" class="w-full border border-dark-primary">
        <div class="flex flex-row">
            <div class="flex-none pt-[1px] items-center">
                <input class="mx-1" type="checkbox" id="checkbox" :checked="isSelected" @change="toggleSelected"/>
            </div>
            <div class="flex-auto">
                <section class="flex justify-between items-center">
                    <div class="flex justify-start">
                        <div class="mr-2">
                            <span class="font-bold">{{ contactName }}</span> <span class="">{{ clientRelationship.title ? ` is ${clientRelationship.title} at ` : 'works for'  }}</span>  <span class="font-bold">{{ clientRelationship.client.client_name }}</span>
                        </div>
                        <div v-if="clientRelationship.is_primary_contact">
                            <base-pill class="bg-accent-primary text-white border-accent-secondary">Primary Contact</base-pill>
                        </div>
                        <div v-if="clientRelationship.is_verified">
                            <base-pill class="bg-accent-secondary text-white border-dark-secondary">Verified Email</base-pill>
                        </div>
                    </div>
                </section>
                <section class="flex flex-col justify-start items-start py-2 text-[0.8rem]  border-b border-gray-400">
                    <ContactClientDetailContactInfo :client-relationship="clientRelationship" @refetch-contacts="fetchNewContacts" />
                </section>
                <section class="flex flex-col justify-start items-start py-2 text-[0.8rem]">
                    <ContactDetailClientInfo :client="clientRelationship.client" @refetch-contacts="fetchNewContacts" />
                </section>
            </div>
        </div>
    </base-card-select>
</template>

<script>
  export default {
    name: 'contact-detail-card',
    data: () => ({
    }),
    methods: {
    }
  }
</script>

<script setup>
import { ref, computed, defineProps, defineEmits, watch, onMounted } from "vue";
import CompanyContactTitleCell from "../company-cell-components/CompanyContactTitleCell.vue";
import ContactDetailClientInfo from "./contact-card-components/ContactDetailClientInfo.vue";
import ContactDetailContactInfo from "./contact-card-components/ContactDetailContactInfo.vue";
import ContactClientDetailContactInfo from "./contact-card-components/ContactClientDetailContactInfo.vue";
import CompanyContactMarkEmailVerifiedCell from "../company-cell-components/CompanyContactMarkEmailVerifiedCell.vue";
import { useStore } from "vuex";
import { updateContactClientRelationship } from '@/services/Contact.js'

const props = defineProps(['contactName','clientRelationship', 'selectedContactId', 'changedContactFilters', 'clearedSelectedContacts', 'clearedSelectedContactsOnPage', 'selectAll', 'selectAllOnPage', 'permissions', 'selectedContactsOnPageMap'])

const emit = defineEmits(['refetch-contacts', 'select-contact', 'deselect-contact'])

const store = useStore()

const fetchNewContacts = () => {
    emit('refetch-contacts')
}

const isSelected = ref(false)

const toggleSelected = () => {
    if(isSelected.value) {
        isSelected.value = false
        emit('deselect-contact')
    } else {
        isSelected.value = true
        emit('select-contact')
    }
}

async function removeClientContact(contactName, contactRelationship){
    const confirm_message = `You are about to archive ${contactName}, ${contactRelationship.title} at ${contactRelationship.client.client_name}.\n Do you wish to proceed?`
    if(window.confirm(confirm_message)){
        const token = store.state.auth.token
        const data = JSON.stringify({
            "status": "inactive"
        })
        await updateContactClientRelationship(contactRelationship.id, data, token)
        emit('refetch-contacts')
    }

}


</script>